module.exports = __webpack_public_path__ + "33915b381dd7b562e4f1c7cd67b814c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/serenity_shares.png
// module id = 1506
// module chunks = 0